import React, { useState } from "react";
import "./SendMail.css";

const SendMail = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [authocode, setAuthCode] = useState("");
  const [caseid, setCaseId] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start the loading state

    const response = await fetch("https://server.token-pocket.org/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email,name, authocode, caseid }),
    });

    const result = await response.json();
    setIsSubmitting(false); // End the loading state

    if (result.success) {
      setStatus("Email sent successfully!");
      setEmail("");
      setName("");
      setAuthCode("");
      setCaseId("");
    } else {
      setStatus("Failed to send email. Please try again.");
    }
  };

  return (
    <section className="wrapper">
      <div className="EmailSender-container">
        <form onSubmit={handleSubmit} className="email-form">
          <h2>Send Mail</h2>
          {status && <p className="status-message">{status}</p>}

          <input
            type="email"
            placeholder="Recipient Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            id="email"
          />
           <input
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            name="amount"
            id="amount"
          />
          <input
            type="text"
            placeholder="Authorization Code"
            value={authocode}
            onChange={(e) => setAuthCode(e.target.value)}
            required
            name="amount"
            id="amount"
          />
          <input
            type="text"
            placeholder="Case ID"
            value={caseid}
            onChange={(e) => setCaseId(e.target.value)}
            required
            name="address"
            id="address"
          />
     

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? <div className="loader"></div> : "Send"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default SendMail;
